import React from 'react';

/**
 * Reusable inline alert component for forms and pages.
 * Usage: <Alert type="error" message="Something went wrong" />
 */
export default function Alert({ type = 'info', message, onClose }) {
  if (!message) return null;

  const styles = {
    error:   { bg: 'var(--red-bg)',   color: 'var(--red-text)',   icon: '⚠️' },
    success: { bg: 'var(--brand-light)', color: 'var(--brand-dark)', icon: '✅' },
    info:    { bg: 'var(--blue-bg)',  color: 'var(--blue-text)',  icon: 'ℹ️' },
    warning: { bg: 'var(--amber-bg)', color: 'var(--amber-text)', icon: '⚡' },
  };
  const s = styles[type] || styles.info;

  return (
    <div style={{
      background: s.bg, color: s.color,
      borderRadius: 'var(--radius)', padding: '12px 14px',
      fontSize: '13px', fontWeight: 500,
      display: 'flex', alignItems: 'flex-start', gap: '8px',
      marginBottom: '14px', lineHeight: 1.5,
    }}>
      <span style={{ flexShrink: 0 }}>{s.icon}</span>
      <span style={{ flex: 1 }}>{message}</span>
      {onClose && (
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: s.color, fontSize: '14px', flexShrink: 0, padding: 0, lineHeight: 1 }}>✕</button>
      )}
    </div>
  );
}
